import React from 'react';
import {
  makeStyles,
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  Link,
  IconButton,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ShowMoreText from 'react-show-more-text'
import { companyType } from '../../tpyes/company-info-type';


// const useStyles = makeStyles((theme) => ({
//   root:{}
// }));

interface ComponentSectionProps {
  open : boolean
  onClose : ()=>void
  content? : companyType
}

const CompanyInfoDialog: React.FC<ComponentSectionProps> = ({
  onClose,
  open,
  content
}) => {
//   const classes = useStyles();

    const founderHandler = (founder:string|undefined) => {
        if (!founder) return "-"
        if (founder.includes("http")) return <Link href={founder} target="_blank">{founder}</Link>
        return <Typography>{founder}</Typography>
    }

    const LogoHandler = (company:companyType|undefined) => {
    if (company?.companyInfo?.logo) return (
      <img 
        style={{width:"100%",borderRadius:"16px"}}
        src={company.companyInfo.logo} 
        alt={company.tradeName} 
      />
    )
    return (
      <Typography className="portal-company-name-title" align="center" variant="h6">{company?.tradeName}</Typography>
    )
  }

    const titleDesc = (title:string,desc:string|undefined) => (
        <Box display="flex">
            <Typography style={{fontWeight:600}}>{title}</Typography>
            <Box flex={1}/>
            <Typography>{desc}</Typography>
        </Box>
    )

  return (
    <Dialog 
    //   className={classes.root}
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      classes={{
          paper:"dialog-paper"
      }}
    >
      <DialogTitle style={{position:"relative"}}>
        {/* <Typography align="center" variant="subtitle1">{content?.tradeName}</Typography> */}
        <IconButton onClick={onClose} style={{left:16,position:"absolute",top:8}}>
            <CloseIcon/>
        </IconButton>
      </DialogTitle>
      <DialogContent>

          {/* <Grid container spacing={2}>
            <Grid item xs={4}>
                <img 
                    src={content?.companyInfo.logo}
                    style={{width:"100%",borderRadius:"16px"}}
                />
            </Grid>
            <Grid item xs={8} style={{display:"flex",flexDirection:"column",justifyContent:"center"}}>
                {titleDesc('website :',content?.website)}
                {titleDesc('contact email :',content?.companyInfo.contactEmail)}
            </Grid>
          </Grid> */}

          {/* <Box py={2}/> */}

          <Grid container justifyContent="center">
            <Grid item xs={6}>
                {LogoHandler(content)}
            </Grid>
          </Grid>

          <Grid container justifyContent="center">
            <Grid item xs={12} className="center" style={{flexDirection:"column"}}>
                <Typography align="center" variant="subtitle1" style={{fontWeight:600}}>{content?.tradeName}</Typography>
                <Box pt={1}/>
                <Link href={content?.website} align="center" target="_blank">{content?.website}</Link>
                <Box pt={1}/>
                <Link href={content?.companyInfo.urlToCcafMapping} align="center" target="_blank">{content?.companyInfo.urlToCcafMapping}</Link>
                {/* <Button 
                  href={content?.website} 
                  target="_blank"
                  disabled={!content?.website} 
                  variant="contained"
                  className="portal-button"
                >
                  Website
                </Button>
                <div className="px1"/>
                <Button 
                  href={content?.companyInfo.urlToCcafMapping} 
                  target="_blank"
                  disabled={!content?.companyInfo.urlToCcafMapping} 
                  variant="contained"
                  className="portal-button"
                >
                  CCAF
                </Button> */}
            </Grid>
          </Grid>
          

          <div className="py1"/>

          <Grid container>
                <Grid item xs={12} style={{display:"flex",flexDirection:"column"}}>
                    <Typography style={{fontWeight:600}}>Founders</Typography>
                    {content?.companyInfo.founder.map(founderHandler)}
                </Grid>
          </Grid>

          <div className="py1"/>

          <Grid container>
                <Grid item xs={12}>
                    <Typography style={{fontWeight:600}}>Description</Typography>
                    <ShowMoreText
                        line={3}
                        more="Show more"
                        less="Show less"
                        expanded={false}
                        truncatedEndingComponent={"... "}
                    >
                        <Typography>{content?.companyInfo.desc}</Typography>
                    </ShowMoreText>
                </Grid>
          </Grid>

          <div className="py1"/>

          <Grid container>
                <Grid item xs={12}>
                    <Typography style={{fontWeight:600}}>Company Info</Typography>
                    <Typography>Contact email : {content?.companyInfo.contactEmail}</Typography>
                    <Typography>Incorporation : {content?.incorporation.city} {content?.incorporation.country}</Typography>
                    <Typography>Since : {content?.incorporation.date ? new Date(content?.incorporation.date).toLocaleDateString("th-TH") : "-"}</Typography>
                </Grid>
          </Grid>

          <div className="py1"/>

          <Grid container>
                <Grid item xs={12}>
                    <Typography style={{fontWeight:600}}>Operation Info</Typography>
                    <Typography>Headquater : {content?.incorporation.operationalHq || "-"} </Typography>
                    <Typography>Served in : {content?.incorporation.countryServed.join(",")}</Typography>
                </Grid>
          </Grid>

          {/* <Grid container className="center">
              <Grid item xs={12} sm={6} md={3} className="center">
                <Button href={content?.website} target="_blank" style={{width:"100%"}} className="portal-button">
                    <Typography style={{color:"white",fontWeight:600}}>visit {content?.tradeName}</Typography>
                </Button>
              </Grid>
          </Grid> */}
      </DialogContent>
    </Dialog>
  )
}

export default CompanyInfoDialog;
